var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#818181",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.516 2.852l.125.016.12.033c.057.02.111.045.165.078l.081.055.093.08 3.146 3.13c.169.165.265.39.267.626.001.15-.036.297-.11.432l-.064.1-.084.098L8.042 19.63c-.083.08-.18.144-.29.188l-.115.038-.102.02-3.666.51c-.276.039-.555-.053-.754-.249-.137-.135-.226-.31-.255-.504l-.01-.119.008-.126.514-3.65c.015-.106.049-.207.103-.304l.061-.095.085-.1L15.833 3.11c.118-.117.266-.199.431-.237l.128-.02.124-.001zM14.38 7.067l-9.274 9.17-.32 2.236 2.163-.277 9.309-9.232-1.878-1.897zm2.087-2.079l-.898.833 1.924 1.902.863-.857-1.889-1.878z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.acf3290cfb8884c1171079bae63b7959.svg";
export { ForwardRef as ReactComponent };